<template>
    <section id="verify">
        <transition name="fade">
            <Loading v-if="isLoading"/>
        </transition>
        <div class="content">
        <h2>輸入驗證碼</h2>
        <img src="../assets/icon-otp.svg" alt="" class="icon">
        <p>已發送至您手機 <span>{{ otpMobile }}</span> 以及信箱 <span>{{ otpEmail }}</span></p>
        <div class="code">
            <span class="frontCode">{{ otpFrontCode }}</span><span>-</span>
            <input type="text" required="required" placeholder="請輸入6位數驗證碼" v-model="otpBackCode" id="otpCode"
                   @keyup="reValBackCode" @keypress="reValBackCode"  @input="reValBackCode" class="inputStyle tlf_n_all"  inputmode="numeric" autocomplete="one-time-code"/>
        </div>
        <div class="countDown mb-50">
            剩餘時間 <vue-countdown :time="otpExpireSec*1000" v-slot="{minutes, seconds}" @end="timeEnd">{{minutes}} : {{seconds}}</vue-countdown>
        </div>
        </div>
        <div class="btnArea">
            <button class="btn send" @click="sendOTP">確定</button>
        </div>
        <div class="otpBottom">
            <div class="container">
                <p class="link" @click="otpAlert">收不到驗證碼嗎?</p>
                <!--                <p><img src="noticemark.svg" alt="" class='attention'>若您的手機或 Email 已變更，請聯繫客服，修改您的個人資料。網路服務專線：0800-366-168</p>-->
            </div>
        </div>
    </section>
</template>
<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2";
import Loading from "@/components/loading.vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
import userStatus from "@/utils/userStatus";

const isLoading = ref(false);
const otpInfo = JSON.parse(sessionStorage.getItem("otp"));
const otpMobile = ref(otpInfo.otpMobile);
const otpEmail = ref(otpInfo.otpEmail);
const otpFrontCode = ref(otpInfo.otpFrontCode);
const otpBackCode = ref("");
const otpExpireSec = ref(
    Math.max(0, Math.floor((new Date(otpInfo.otpExpireTime) - new Date()) / 1000))
);
const router = useRouter();
const sourceRemark = "活動-FY24";

// 驗證碼輸入處理
const reValBackCode = () => {
    otpBackCode.value = otpBackCode.value.replace(/[^0-9]/g, "").substr(-6);
};
// 發送驗證碼
const sendOTP = () => {
    if (!otpBackCode.value) {
        alertFunc("<p>請輸入驗證碼</p>", "輸入錯誤", "errormark");
        return;
    }
    if (otpInfo.type === "login") {
        checkLoginOTP();
    }
    // else if (otpInfo.type === "register") {
    //     checkRegisterOTP();
    // }
};

// 驗證登入 OTP
const checkLoginOTP = () => {
    isLoading.value = true;
    const otpData = {
        otpId: otpInfo.otpId,
        otpFrontCode: otpInfo.otpFrontCode,
        otpBackCode: otpBackCode.value,
        birthday: JSON.parse(sessionStorage.getItem("logData")).birthday,
        sourceRemark,
    };
    userStatus.checkOtpLogin(
        otpData,
        (jwtInfo) => {
            localStorage.setItem("jwtInfo", JSON.stringify(jwtInfo));
            sessionStorage.removeItem("otp");
            sessionStorage.setItem("login41", true);
            sessionStorage.setItem("isLogin", true);
            router.push("/FY24_luckydraw#login");
        },
        (res) => {
            alertFunc(`<p>${res.message}</p>`, "OTP 送出異常", "errormark");
            isLoading.value = false;
        },
        () => {
            alertFunc("<p>確認OTP連線錯誤</p>", "系統異常", "errormark");
            isLoading.value = false;
        }
    );
};

// 驗證碼到期處理
const timeEnd = () => {
    alertFunc("<p>您的驗證碼已到期！將回到上一頁</p>", "驗證碼失效", "errormark", () => {
        sessionStorage.removeItem("otp");
        router.push("/FY24_luckydraw");
    });
};

// 錯誤提示
const alertFunc = (errorTxt, errorTitle, icon, thenCallback, extraClass = "") => {
    const containerClass = ["swal-S", extraClass].filter(Boolean).join(" ");
    Swal.fire({
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: '確定',
        customClass: {
            container: containerClass,
        },
        html: `<img src="${require('../assets/' + icon + '.svg')}" alt="Error"><div><h3 class="alertTitle">${errorTitle}</h3>${errorTxt}</div>`,
    }).then(thenCallback);
};

// 收不到驗證碼提示
const otpAlert = () => {
    alertFunc("<ul><li>請確認您的會員手機或Email是否正確。</li>" +
        "<li>是否有拒收企業簡訊的設定(建議可洽詢您的電信業者更改設定)。</li>" +
        "<li>請確認目前所在位置收訊良好。</li>" +
        "<li>有可能被誤判定為垃圾簡訊及垃圾Email，請至垃圾訊息區確認。</li>" +
        "<li>若您的手機或 Email 已變更，請聯繫客服，修改您的個人資料。客服專線：0800-366-168</li></ul>", "若您一直沒有收到驗證碼", "noticemark", () => {
        // 這裡可以加入後續操作，例如導向客服頁面等
    }, "otpAlert");
};
</script>

<style lang="scss">
#verify {
    background: $white;
    padding: 175px 0 0;
    text-align: center;
    box-sizing: border-box;
    color: $black;
    .content{
        padding-top:50px;
        width:1280px;
        box-sizing: border-box;
        border-radius: 20px;
        margin:0 auto 60px;
        border: 1px solid #e8e8e8;
        @media screen and (max-width: $pc) {
            width: 90%;
        }
        @media screen and (max-width: $mobile-small) {
            width: 100%;
            border:none;
        }
    }
    .icon {
        display: inline-block;
        margin: 50px auto;
    }

    h2 {
        color: $black;
        margin: 0;
        font-size: 30px;
    }

    .code {
        display: flex;
        width: 500px;
        margin: 40px auto;

        @media screen and (max-width: $mobile-small) {
            width: 95%;
        }

        span {
                font-weight: 500;
                font-size: 22px;
                vertical-align: bottom;
                line-height: 150%;
        }

        .inputStyle {
            height: 40px;
            line-height: 41px;
            box-sizing: border-box;
            position: relative;
            padding: 8px 20px;
            margin-left: 10px;
            width: calc(100% - 50px);
            border: 1px solid $gray-600;
            border-radius: 20px;
            background: $white;
            font-size: 16px;
            color: $gray-600;
        }
    }
    .otpBottom{
        text-align:center;
        padding-bottom:80px;
        .container{
            font-size:16px;
            line-height:25px;
            .attention{width:16px;margin-right:5px;position: relative;top:2px;}
            @media screen and (max-width: $mobile-small){
                width:100%;
            }
        }
    }
    .btnArea{margin:0 0 40px;}
    @media screen and (max-width: $pad) {
        margin-top: 10%;
    }
    @media screen and (max-width: $mobile-small) {
        margin-top: 15%;
        .btn {
            width: 40%;
            margin: 0 2%;
        }
    }

    .vue-countdown {
        display: inline-block;
    }

    .btn.send {
        background: $pink-800;
    }
}

.otpAlert .swal2-html-container {
    p {
        text-align: left;
    }

    ul {
        list-style-type: decimal;
        text-align: left;
        padding: 0 20px;
    }
}

</style>



